module.exports = __webpack_public_path__ + "static/media/UserExperience.269622e3.png";